export default {
  kidsBadge: "Fun English Club",
  playAndLearnWorld: "Play & Learn World",
  smartKidsSite: "For Smart Kids",
  footerBrandDesc: "Making English learning an exciting adventure through interactive games, cartoons, and colorful worksheets!",
  learningFeaturesTitle: "Our Adventure Hub",
  games: "Brain Games",
  videos: "Cartoons & Video",
  songs: "Fun Songs",
  worksheets: "Worksheets",
  stories: "Audio Stories",
  painting: "Coloring",
  contactUs: "Get in Touch",
  phoneNumber: "Phone Support",
  email: "Support Email",
  parentsSafeBadge: "100% Safe & Parent-Approved Environment",
  allRightsReserved: "All Rights Reserved for Kids World",
   footer_copyright_prefix: '🎈 All rights reserved for',
  footer_copyright_company: 'Iran Phonics',
  footer_copyright_suffix: '🚀',
  footer_dev_credit_prefix: 'Designed & Developed by',
  footer_dev_credit_company: 'Shno Soft',
  footer_address_title: '📍 Our Adventure Hub',
  footer_address_text: 'No. 256, Corner of Ravanmehr, 12 Farvardin St, Enqelab, Tehran',
};
